<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="text">Примечание</label>
    <textarea
      id="text"
      cols="30"
      rows="2"
      class="form-control"
      placeholder="Введите примечание"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)">
    </textarea>
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'notation-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>


// WEBPACK FOOTER //
// Notation.vue?3d4c79c7